import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ImageCroppedEvent, ImageCropperModule } from 'ngx-image-cropper';

export type CropperDialogData = {
  image: File;
  width: number;
  height: number;
};

export type CropperDialogResult = {
  blob: Blob;
  imageUrl: string;
};

@Component({
  selector: 'lib-cropper-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ImageCropperModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
  ],
  template: `
    <div class="mx-10">
      <div class="mt-5 mb-2">
        <div class="flex justify-between text-xl font-semibold">
          <div class="text-mdPrimary-500">Please crop your image</div>
          <mat-icon mat-dialog-close="true" class="cursor-pointer"
            >close</mat-icon
          >
        </div>
        <hr class="mt-3" />
      </div>

      <div mat-dialog-content>
        <image-cropper
          [maintainAspectRatio]="true"
          [aspectRatio]="data.width / data.height"
          [resizeToHeight]="data.height"
          [resizeToWidth]="data.width"
          [onlyScaleDown]="true"
          [imageFile]="data.image"
          (imageCropped)="imageCropped($event)"
        ></image-cropper>
      </div>

      <div align="center" mat-dialog-actions>
        <button mat-button [mat-dialog-close]="false">Cancel</button>
        <button
          mat-flat-button
          color="primary"
          [mat-dialog-close]="result()"
          cdkFocusInitial
        >
          Done
        </button>
      </div>
    </div>
  `,
  styles: [],
})
export class CropperDialogComponent {
  data: CropperDialogData = inject(MAT_DIALOG_DATA);

  result = signal<CropperDialogResult | undefined>(undefined);

  imageCropped(event: ImageCroppedEvent) {
    const { blob, objectUrl } = event;
    if (blob && objectUrl) {
      this.result.set({ blob, imageUrl: objectUrl });
    }
  }
}
